import React from 'react';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
    meter: {
        display: 'block',
        minWidth: 100,
        minHeight: '1rem',
        border: '2px solid darkgrey',
        background: 'gray',
        position: 'relative',
        borderRadius: 5,
        '&::after': {
            content: '""',
            position: 'absolute',
            left: 0,
            top: 0,
            bottom: 0,
            width: 'calc(var(--progress) * 100%)',
            background: 'var(--color)',
        },
    },
});

export const Meter: React.FunctionComponent<{
    min: number,
    max: number,
    value: number,
    color: string,
    'aria-labelledby': string,
}> = props => {
    const diff = props.max - props.min;
    const progress = diff > 0 ? Math.min(1, Math.max(0, props.value / diff)) : 0;
    const styles = useStyles();
    return (
        <div
            role="meter"
            aria-valuemin={props.min}
            aria-valuemax={props.max}
            aria-valuenow={props.value}
            style={{ '--progress': progress, '--color': props.color } as React.CSSProperties}
            className={styles.meter}
        ></div>
    );
};
